import React from 'react';
import '../ndot.scss';

const NDOTAttachment = () => {
    const search = window.location.search;
    const param = new URLSearchParams(search);
    const file = param.get('f');

    const getFileType = file.split('.');
    const fileType = getFileType[getFileType.length - 1];

    return (
        <div className='file'>
            { fileType === 'png' || fileType === 'jpeg' || fileType === 'jpg'
                ? (
                    <img src={file} title={getFileType[0]} />
                ) : (
                    <iframe src={`//docs.google.com/gview?url=${file}&embedded=true`} id="docs-iframe" style={{ width: '100%', minHeight: '90vh', margin: 'auto'}}></iframe>
                )
            }
        </div>
    )
}

export default NDOTAttachment;